module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/maria_on-0c7f7aee16c6958ce6583ac500b23ec7.gif";